// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontNohemi_cea94a', '__fontNohemi_Fallback_cea94a'"},"className":"__className_cea94a","variable":"__variable_cea94a"};